import React, { useEffect, useState } from 'react'

import { useCognito } from '../CognitoContextProvider'
import Modal from 'components/Shared/Modal'
import AccountDisabled from './AccountDisabled'

export default function InactiveUserModal() {
  const { error } = useCognito()

  const [errorModalOpen, setErrorModalOpen] = useState(
    error?.includes('error.auth.inactive')
  )

  useEffect(() => {
    if (error?.includes('error.auth.inactive') && !errorModalOpen) {
      setErrorModalOpen(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  if (!errorModalOpen) return null

  return (
    <Modal
      closeCallback={() => setErrorModalOpen(false)}
      hideCloseBtn
      title={''}
      mainContent={<AccountDisabled closeModal={() => setErrorModalOpen(false)} />}
      fullWidth={false}
      timeoutCloseCallback={() => {}}
    />
  )
}
